<template>
    <div v-if="shouldShow" class="text-danger small">
        {{ $errors.first(input) }}
    </div>
</template>

<script>

export default {
    props: ['input'],
    data: () => ({

    }),
    methods: {},
    computed: {
        shouldShow() {
            return this.$errors.has(this.input);
        }
    },
    watch: {},
    mounted() {}
}
</script>

<style scoped>

</style>
